import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function createPageDraft(pageId, fresh = false) {
  const token = await retrieveAccessToken();
  const response = await axios.post(`/api/editor/page/${encodeURIComponent(pageId)}/draft${fresh ? '?fresh=true' : ''}`, null, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
  return response.data;
}
